import { type ReactElement } from 'react'
import { type IconName } from '@/icon-name'

export enum ButtonStyle {
  Primary = 'primary',
  Secondary = 'secondary',
  Danger = 'danger',
  Subtle = 'subtle',
  Alternative = 'alternative',
}

export enum ButtonType {
  Download = 'download',
  Default = 'default',
  StravaConnect = 'strava-connect',
  StravaPremium = 'strava-premium',
}

export enum Align {
  Center = 'center',
  Left = 'left',
}

export type Link = {
  title: string
  url: string
  className?: string
  active?: boolean
}

export type Button = {
  text: string
  link: string
  ctaEvent?: string
  buttonStyle: ButtonStyle
  buttonType: ButtonType
  className?: string
  icon?: ReactElement | { type?: any; props?: any; key?: any }
  external?: boolean
}

export type Logo = {
  name: IconName
  title: string
  link: string
  className?: string
}

export type NavbarSettings = {
  fixed: boolean
  transparent: boolean
  showLanguageSelector: boolean
  showSearch: boolean
  align?: Align
  logo: Logo
  secondaryLogo?: string
  secondaryLogoLink?: string
  navLinks?: Link[]
  buttons?: Button[]
}
